import { Injectable } from '@angular/core';
import {from, Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {classToPlain, plainToClass} from 'class-transformer';
import {db} from "../../dexie/db";

import { SOPutReport } from './so-put-report';
import { SOGetReport } from './so-get-report';
import { SOPostReport } from './so-post-report';
import { SODeleteReport } from './so-delete-report';
import {SORespReport} from './so-resp-report';
import {SOPluralReport} from './so-plural-report';

import {MMEntityService} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {MMEntityServiceBase} from 'lionheartland';
import {HttpHeaders} from "@angular/common/http";

export class EOReportService extends MMEntityServiceBase implements MMEntityService {

  constructor(
    public entityCore: EntityCoreProtocol,
  ) {
    super('report', entityCore);
  }

  /** GET Report by id. Will 404 if id not found */
  get(request: SOGetReport): Observable<SOPluralReport> {
    return this.httpClient.get<SOPluralReport>(this.makeGetUri(request), this.httpOptions).pipe(
      map(resp => plainToClass(SOPluralReport, resp)),
      tap(async (response: SOPluralReport) => {
        this.log(`fetched Report`);
        // After a successful server response, update IndexedDB
        const activities = response.toReports(); // Convert your response to an array of Report instances
        const promises = activities.map(report => db.reports.put(report));
        await Promise.all(promises); // Wait for all the IndexedDB update operations to complete
      }),
      catchError(this.handleError<SOPluralReport>(`get Report`))
    );
  }

    /** GETCACHE for initial display with CacheQueryProtocol */
    getCache(cacheQuery: any): Observable<SOPluralReport> {
        console.log("GETCACHE", cacheQuery);

        if (cacheQuery.filterKey === 'report' && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on parent and organization")
            return from(db.reports.where('parentUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(reportsArray => this.processReports(reportsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }
        else if (cacheQuery.filterKey + "s" == "period" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.reports.where('periodUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(reportsArray => this.processReports(reportsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "assessments" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.reports.where('assessmentsUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(reportsArray => this.processReports(reportsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "project" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.reports.where('projectUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(reportsArray => this.processReports(reportsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "organization" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.reports.where('organizationUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(reportsArray => this.processReports(reportsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterOrganization || cacheQuery.organization.uid)
        {
            console.log("tripped organization for cache query")
            if ( cacheQuery?.filterOrganization != null )
            {
                console.log("cache filtering based on organization CQP", cacheQuery)
                return from(db.reports.where('organizationUid').equals(cacheQuery.filterOrganization).toArray()).pipe(
                    map(reportsArray => this.processReports(reportsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else if ( cacheQuery?.organization?.uid != null )
            {
                console.log("UID:", cacheQuery.organization.uid)
                console.log("cache filtering based on organization SOGet")
                return from(db.reports.where('organizationUid').equals(cacheQuery.organization.uid).toArray()).pipe(
                    map(reportsArray => this.processReports(reportsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else
            {
                console.log("null organization")
            }
        }
        else
        {
            console.log("cache no filter")
            return from(db.reports.toArray()).pipe(
                map((reportsArray) => {
                    // Convert the array of plain objects to an array of SORespReport instances
                    const sorReports = reportsArray.map(req => plainToClass(SORespReport, req));
                    // Create and return a new instance of SOPluralReport
                    const pluralReport = new SOPluralReport();
                    pluralReport.objects = sorReports;
                    pluralReport.nextOffset = null; // Assuming there is no pagination in cache
                    return pluralReport;
                }),
                catchError(error => this.handleQueryError(error))
            );
        }
    }

    private processReports(reportsArray) {
        const sorReports = reportsArray.map(req => plainToClass(SORespReport, req));
        const pluralReport = new SOPluralReport();
        pluralReport.objects = sorReports;
        pluralReport.nextOffset = null;
        return pluralReport;
    }

    private handleQueryError(error) {
        console.error('Error in query:', error);
        return throwError(error); // Return an observable error
    }

post(request: SOPostReport): Observable<SORespReport> {
  return this.httpClient.post<SORespReport>(this.coreUrl + this.route, request, this.httpOptions).pipe(
    map(resp => plainToClass(SORespReport, resp)),

    tap(async (response: SORespReport) => {
      this.log(`added Report w/ id=${response.uid}`);
      // After a successful server response, update IndexedDB
      console.log("here", response);
      console.log("here request", request);
      await db.reports.add(response.toReport());
    }),
    catchError(this.handleError<SORespReport>('Report post'))
  );
}


  put(request: SOPutReport): Observable<SORespReport> {
    const uid = request.uid;
    const uri = `${this.coreUrl}${this.route}/${uid}`;
    return this.httpClient.put<SORespReport>(uri, request, this.httpOptions).pipe(
      map(resp => plainToClass(SORespReport, resp)),
      tap(async (response: SORespReport) => {
        this.log(`edited Report w/ uid=${uid}`);
        // After a successful server response, update IndexedDB
        await db.reports.put(response.toReport());
      }),
      catchError(this.handleError<SORespReport>('Report put'))
    );
  }


  delete(request: SODeleteReport): Observable<SORespReport> {
    return this.httpClient.delete<SORespReport>(this.makeDeleteUri(request), this.httpOptions).pipe(
      tap(async _ => {
        this.log(`deleted Report uid=${request.uid}`);
        // After a successful server response, update IndexedDB
        await db.reports.delete(request.uid);
      }),
      catchError(this.handleError<SORespReport>('Report delete'))
    );
  }


}
